import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Popconfirm, message, Tooltip, Tag } from "antd";
import { EditOutlined, CheckCircleOutlined, StopOutlined, CopyOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItem } from "../../../../Components/Items";
import { cmmsPost, OPCIONES_ESTADO } from "../cmmsComun";
import ModalRutina from "./ModalRutina";

// Rutinas de mantenimiento (listas de pasos). Se asignan en Tipos de Activo.
class Rutinas extends Component {
    state = { loading: false, rutinas: [], valor: 1, modal: false, modo: "agregar", rutinaId: null };

    componentDidMount() {
        this.consultar();
    }

    consultar = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "selectRutinasCMMS", { valor: this.state.valor });
            this.setState({ rutinas: res.data.success === 2 ? res.data.rutinas : [] });
        } catch (error) {
            console.log(error);
            message.error("Error al consultar las rutinas");
        } finally {
            this.setState({ loading: false });
        }
    };

    accion = async (ruta, body, exito) => {
        try {
            const res = await cmmsPost(this.props, ruta, body);
            if (res.data.success === 2) {
                if (exito) message.success(exito);
                this.consultar();
            } else message.error(res.data.message || "No se pudo completar la acción");
        } catch (error) {
            console.log(error);
        }
    };

    render() {
        const columns = [
            { title: "Folio", dataIndex: "codigo", key: "codigo", buscar: "codigo", width: 110 },
            { title: "Título", dataIndex: "titulo", key: "titulo", buscar: "titulo", sorter: (a, b) => (a.titulo || "").localeCompare(b.titulo || "") },
            { title: "Tipo de servicio", dataIndex: "tipoServicioNombre", key: "tipoServicioNombre", width: 190 },
            { title: "Secciones", dataIndex: "totalSecciones", key: "totalSecciones", width: 90 },
            { title: "Actividades", dataIndex: "totalActividades", key: "totalActividades", width: 100 },
            {
                title: "Usada en",
                dataIndex: "tiposNombres",
                key: "tiposNombres",
                render: (v) => (v || []).map((n) => <Tag key={n}>{n}</Tag>),
            },
            {
                title: "Acción",
                key: "acciones",
                fixed: "right",
                align: "center",
                width: 130,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (value) => (
                    <div className="acciones-container">
                        <Tooltip title="Editar">
                            <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ modal: true, modo: "editar", rutinaId: value._id })} />
                        </Tooltip>
                        <Tooltip title="Duplicar">
                            <ButtonItem type="default" size="small" blanco icon={<CopyOutlined />} onClick={() => this.accion("duplicarRutinaCMMS", { id: value._id }, "Rutina duplicada")} />
                        </Tooltip>
                        <Popconfirm
                            title={value.estado === 1 ? "¿Deshabilitar esta rutina?" : "¿Habilitar esta rutina?"}
                            onConfirm={() => this.accion("cambiarEstadoRutinaCMMS", { id: value._id, estado: value.estado === 1 ? 2 : 1 })}
                            okText="Sí"
                            cancelText="No"
                        >
                            <Tooltip title={value.estado === 1 ? "Deshabilitar" : "Habilitar"}>
                                {value.estado === 1 ? (
                                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                                ) : (
                                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                                )}
                            </Tooltip>
                        </Popconfirm>
                    </div>
                ),
            },
        ];
        return (
            <>
                <PageHeader
                    title="Rutinas"
                    subTitle="Mantenimiento"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            {window.innerWidth > 1000 && <SegmentedItem options={OPCIONES_ESTADO} value={this.state.valor} onChange={(valor) => this.setState({ valor }, this.consultar)} />}
                            <ButtonItem type="primary" olivo className="botonAgregar" onClick={() => this.setState({ modal: true, modo: "agregar", rutinaId: null })}>
                                Agregar Rutina
                            </ButtonItem>
                        </>
                    }
                />
                <TableItem
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.rutinas}
                    columns={columns}
                    pagination={true}
                    onRow={(r) => ({ onDoubleClick: () => this.setState({ modal: true, modo: "editar", rutinaId: r._id }) })}
                />
                <ModalRutina visible={this.state.modal} modo={this.state.modo} rutinaId={this.state.rutinaId} onClose={() => this.setState({ modal: false }, this.consultar)} />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Rutinas);
